module.exports = __webpack_public_path__ + "static/media/events.250ddbb3.svg";